const toggleAlert = (alert) => dispatch => {
    dispatch({
        type: "TOGGLE_APP_ALERT",
        payload: alert
    })
}

export {
    toggleAlert
}